import * as React from 'react';
import { ArticleHeading4, ArticleParagraph3, ArticleParagraph2 } from '@cian/ui-kit';
import * as styles from './BuilderCardDesktop.css';
import { IBuilderCardBaseProps } from '../types';
import { Logo } from '../../Logo';
import { LinkArea } from '../../LinkArea';

export interface IBuilderCardDesktopProps extends IBuilderCardBaseProps {
  age: number;
}

export function BuilderCardDesktop({
  age,
  name,
  logo,
  phoneButton,
  link,
  materials,
  projectStartPrice,
  projectsTypes,
  onClickLink,
  label,
}: IBuilderCardDesktopProps) {
  return (
    <LinkArea
      href={link}
      target="_blank"
      onClick={onClickLink}
      className={styles['container']}
      dataName="BuilderCardDesktop"
    >
      <div className={styles['company']}>
        <div className={styles['logo']}>
          <Logo src={logo} size={68} />
        </div>
        <div className={styles['company-info']}>
          <ArticleHeading4 color="primary_100" as="div">
            {name}
          </ArticleHeading4>
          <ArticleParagraph3 as="div">Работает с {age} года</ArticleParagraph3>
          {label && <div className={styles['label']}>{label}</div>}
        </div>
      </div>
      <div className={styles['card-info']}>
        <div className={styles['projects']}>
          {projectsTypes && (
            <>
              <ArticleParagraph2 display="block">{projectsTypes}</ArticleParagraph2>
              <ArticleParagraph2 display="block">{projectStartPrice}</ArticleParagraph2>
            </>
          )}
        </div>
        <div className={styles['materials']}>{materials}</div>
        <div className={styles['button-phone']}>{phoneButton}</div>
      </div>
    </LinkArea>
  );
}
